import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AppSettingsService } from '@app/services/app-settings/app-settings';

export async function appSettingsInitializer(): Promise<void> {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return;
  }

  await firstValueFrom(inject(AppSettingsService).load());
}
